/**
 * Replaces /utils/globalFilters.js in Reservation System (/WebClient). As a standard JS file the functions
 * in this file can be used anywhere whereas globalFilters can only used with Vue filters.
 */

const LOCALE = 'en-US';

/**
 * Formats currency in USD only.
 */
export const toCurrency = val => {
  if (typeof val !== 'number') {
    return val;
  }

  const formatter = new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: 'USD'
  });

  return formatter.format(val);
}

/**
 * Gets today's date (no time) in GMT. Depends on browser to render in client's machine (presumably) local date.
 * @returns {string}
 */
export const toDay = () => {
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };

  return new Date().toLocaleDateString('en-us', options);
}
